export default ({

    namespaced: true,

    state: {
        dialog: false,
    },

    getters: {
        getDialog(state){
            return state.dialog
        }
    },

    mutations: {
        setDialog(state, payload){
            state.dialog = payload
        }
    },

    actions: {
        handleDialogUpload({ commit }, payload){
            commit('setDialog', payload)
        }
    }
})